export function roundToTwoDecimalPlaces(num: number | null): string {
    if (num === null) {
        return '0.00';
    }
    return num.toFixed(2);
}
